export const BASE_URL =
  'https://us-central1-bestweddingappweb.cloudfunctions.net/api';
